/* FuzzYard · Navidad 2026 · lógica de la sección fy-xmas-gifts */
(function(){
function initFyx(root){
  if(!root || root.dataset.fyxInit) return;
  root.dataset.fyxInit = '1';

  var designMode = !!(window.Shopify && Shopify.designMode);
  var end = (root.dataset.end || '').replace(/-/g,'');
  if(end.length === 8 && !designMode){
    var d = new Date(), today = d.getFullYear()*10000 + (d.getMonth()+1)*100 + d.getDate();
    if(today > parseInt(end,10)){ root.style.display = 'none'; return; }
  }

  var T = {};
  try { T = JSON.parse(root.querySelector('[data-fyx-t]').textContent || '{}'); } catch(e) {}
  // "10 %" sin partir en dos líneas
  Object.keys(T).forEach(function(k){ if(typeof T[k] === 'string') T[k] = T[k].replace(/ %/g, ' %'); });
  var SHIP = parseInt(root.dataset.ship, 10) || 0;
  var lastCount = -1;

  var MIN = parseInt(root.dataset.min,10) || 3;
  var PCT = parseInt(root.dataset.percent,10) || 10;
  var DEMO = root.dataset.demo === '1';
  var routes = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var ids = [];
  try { ids = JSON.parse(root.querySelector('[data-xmas-ids]').textContent || '[]'); } catch(e) { ids = []; }
  var gifts = Array.prototype.slice.call(root.querySelectorAll('[data-gift]'));
  gifts.forEach(function(g){ if(g.dataset.productId){ var pid = parseInt(g.dataset.productId,10); if(ids.indexOf(pid) < 0) ids.push(pid); } });

  var slots = Array.prototype.slice.call(root.querySelectorAll('[data-slot]'));
  var bar = root.querySelector('[data-bar]');
  var status = root.querySelector('[data-status]');
  var totalEl = root.querySelector('[data-total]');
  var demoCart = [];
  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  var locale = document.documentElement.lang || 'es';

  function money(cents){
    try { return new Intl.NumberFormat(locale, {style:'currency', currency: currency}).format(cents/100); }
    catch(e){ return (cents/100).toFixed(2).replace('.', ',') + ' €'; }
  }

  // Abrir regalos
  function openGift(g){
    if(g.classList.contains('is-open')) return;
    g.classList.add('is-open');
    var box = g.querySelector('.fyx-gift__box');
    if(box) box.setAttribute('aria-expanded','true');
    status.textContent = T.opened_x.replace('[T]', g.dataset.title || '');
    var add = g.querySelector('[data-add]');
    if(add) setTimeout(function(){ add.focus({preventScroll:true}); }, 350);
    if(window.dataLayer){ window.dataLayer.push({event:'fyx_open_gift', promotion_name: root.dataset.promo, item_name: g.dataset.title}); }
  }
  gifts.forEach(function(g){
    g.querySelectorAll('[data-open]').forEach(function(b){ b.addEventListener('click', function(){ openGift(g); }); });
    g.querySelectorAll('.fyx-sizes input').forEach(function(r){
      r.addEventListener('change', function(){
        var add = g.querySelector('[data-add]'); if(add) add.dataset.variantId = r.value;
        var pr = g.querySelector('[data-price]'); if(pr && r.dataset.price) pr.textContent = r.dataset.price;
      });
    });
  });

  // Pinta el progreso a partir de las líneas del carrito que cuentan para la oferta
  function paint(lines){
    var count = 0, sum = 0, imgs = [], inCart = {}, cartTotal = lines.cartTotal;
    lines.forEach(function(l){
      count += l.quantity; sum += l.line_price;
      inCart[l.product_id] = true;
      for(var q = 0; q < l.quantity && imgs.length < MIN; q++){ imgs.push({src: l.image, title: l.title}); }
    });
    slots.forEach(function(sl, i){
      var it = imgs[i];
      if(it){
        var key = (it.src || '') + '|' + it.title;
        if(sl.dataset.key !== key){
          sl.dataset.key = key;
          sl.classList.add('is-filled');
          sl.innerHTML = it.src ? '<img src="' + it.src + (it.src.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="">' : '<span class="fyx-slot__n">&#10003;</span>';
          var im = sl.querySelector('img'); if(im) im.alt = it.title || '';
        }
      } else if(sl.classList.contains('is-filled')){
        sl.classList.remove('is-filled');
        sl.dataset.key = '';
        sl.innerHTML = '<span class="fyx-slot__n" aria-hidden="true">' + (i+1) + '</span>';
      }
    });
    var done = count >= MIN;
    root.classList.toggle('is-done', done);
    bar.style.width = Math.min(count, MIN) / MIN * 100 + '%';
    var left = MIN - count;
    var shipTxt = '';
    if(done && SHIP && typeof cartTotal === 'number' && T.ship_left){ shipTxt = ' · ' + (cartTotal >= SHIP ? T.ship_ok : T.ship_left.replace('[S]', money(SHIP - cartTotal))); }
    status.textContent = count === 0 ? T.p_zero : (done ? T.p_done.replace('[P]', PCT) + shipTxt : (left === 1 ? T.p_left1 : T.p_left).replace('[L]', left).replace('[P]', PCT));
    totalEl.textContent = count === 0 ? T.t_zero : (done ? T.t_done.replace('[S]', money(Math.round(sum * PCT / 100))) : T.t_some.replace('[T]', money(sum)));
    gifts.forEach(function(g){
      var key = g.dataset.productId ? parseInt(g.dataset.productId,10) : g.querySelector('[data-add]') && g.querySelector('[data-add]').dataset.variantId;
      var has = !!inCart[key];
      g.classList.toggle('is-in-cart', has);
      var add = g.querySelector('[data-add]');
      if(add && !add.disabled) add.textContent = has ? T.add_more : T.add;
    });
  }

  function refresh(){
    if(DEMO){ paint(demoCart); return Promise.resolve(); }
    return fetch(routes + 'cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(cart){
        // cart.js devuelve primero lo último añadido: se invierte para llenar los huecos en orden
        var lines = (cart.items || []).slice().reverse().filter(function(l){ return ids.indexOf(l.product_id) > -1; });
        lines.cartTotal = cart.total_price;
        paint(lines);
        var n = 0; lines.forEach(function(l){ n += l.quantity; });
        // Al completar la oferta desde aquí se abre el carrito (con el descuento ya aplicado)
        if(lastCount > -1 && lastCount < MIN && n >= MIN && root.dataset.justAdded === '1'){
          setTimeout(function(){ try { if(window.kachingCartApi) window.kachingCartApi.openCart(); } catch(e){} }, 1200);
        }
        root.dataset.justAdded = '';
        lastCount = n;
        var sel = root.dataset.countSelector;
        if(sel){ document.querySelectorAll(sel).forEach(function(el){ el.textContent = cart.item_count; }); }
        return cart;
      })
      .catch(function(){ paint([]); });
  }

  // Añadir al carrito (AJAX)
  root.addEventListener('click', function(e){
    var btn = e.target.closest('[data-add]');
    if(!btn || btn.disabled) return;
    var g = btn.closest('[data-gift]');
    btn.disabled = true;
    btn.textContent = T.adding;
    var title = g ? g.dataset.title : '';

    var job;
    if(DEMO){
      demoCart.push({product_id: btn.dataset.variantId, quantity: 1, line_price: Math.round(parseFloat(btn.dataset.unit || '0')), image: '', title: title});
      job = Promise.resolve();
    } else {
      // Sin abrir el carrito lateral en cada regalo: solo al completar la oferta
      var f = window.__kachingCartOriginalFetch || window.fetch;
      job = f.call(window, routes + 'cart/add.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({items:[{id: parseInt(btn.dataset.variantId,10), quantity: 1}]})
      }).then(function(r){ return r.json().then(function(j){ if(!r.ok) throw j; return j; }); });
    }

    job.then(function(){
      if(root.dataset.afterAdd === 'cart' && !DEMO){ window.location.href = routes + 'cart'; return; }
      root.dataset.justAdded = '1';
      try { if(window.kachingCartApi) window.kachingCartApi.refreshCart(); } catch(e){}
      btn.textContent = T.added; btn.classList.add('is-done');
      status.textContent = T.added_msg.replace('[T]', title);
      if(window.dataLayer){ window.dataLayer.push({event:'add_to_cart_promo', promotion_name: root.dataset.promo, creative_slot:'home_xmas_gifts', item_name: title}); }
      return refresh().then(function(cart){
        if(cart){
          document.dispatchEvent(new CustomEvent('fyx:cart:updated', {detail: cart}));
          document.dispatchEvent(new CustomEvent('cart:refresh', {detail: cart}));
        }
      });
    }).catch(function(err){
      btn.textContent = (err && err.description) ? T.nostock_more : T.fail;
      status.textContent = btn.textContent;
    }).finally(function(){
      setTimeout(function(){ btn.disabled = false; btn.classList.remove('is-done'); var gg = btn.closest('[data-gift]'); btn.textContent = gg && gg.classList.contains('is-in-cart') ? T.add_more : T.add; }, 1600);
    });
  });

  // Si el carrito cambia desde otra parte de la web, se actualiza el pack
  var tm;
  function soon(ms){ clearTimeout(tm); tm = setTimeout(refresh, ms || 350); }
  ['fyh:cart:updated','cart:updated','cart:refresh','fyo:cart:changed'].forEach(function(ev){ document.addEventListener(ev, function(){ soon(300); }); });
  document.addEventListener('visibilitychange', function(){ if(!document.hidden) soon(100); });
  window.addEventListener('pageshow', function(){ soon(100); });
  // Cambios hechos en el carrito lateral (quitar, sumar o restar): se vuelve a leer el carrito
  document.addEventListener('click', function(e){ if(root.contains(e.target)) return; setTimeout(function(){ soon(50); }, 900); setTimeout(function(){ soon(50); }, 2400); }, true);

  // Pausa (accesibilidad: movimiento automático de más de 5 s)
  var pauseBtn = root.querySelector('.fyx-pause');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function setPaused(p){
    root.classList.toggle('is-paused', p);
    pauseBtn.setAttribute('aria-pressed', p ? 'true' : 'false');
    pauseBtn.setAttribute('aria-label', p ? T.resume : T.pause);
    pauseBtn.innerHTML = p ? '&#9654;' : '&#10074;&#10074;';
  }
  pauseBtn.addEventListener('click', function(){ setPaused(!root.classList.contains('is-paused')); });
  if(reduce) setPaused(true);

  if('IntersectionObserver' in window){
    new IntersectionObserver(function(entries){
      entries.forEach(function(en){ root.classList.toggle('is-running', en.isIntersecting); });
    }, {threshold: 0.1}).observe(root);
  } else { root.classList.add('is-running'); }

  var cta = root.querySelector('.fyx-cta');
  if(cta){ cta.addEventListener('click', function(){ if(window.dataLayer){ window.dataLayer.push({event:'select_promotion', ecommerce:{promotion_name: root.dataset.promo, creative_slot:'home_xmas_gifts'}}); } }); }

  // Cuenta atrás de entrega (los últimos 14 días)
  var dl = root.querySelector('.fyx-deadline'), dd = (root.dataset.deadlineDate || '').split('-');
  if(dl && dd.length === 3 && T.cd_n){
    var now = new Date(), cut = new Date(+dd[0], +dd[1]-1, +dd[2]);
    var today0 = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var days = Math.round((cut - today0) / 86400000);
    if(days < 0) dl.style.display = 'none';
    else if(days === 0) dl.textContent = T.cd_1;
    else if(days <= 14) dl.textContent = T.cd_n.replace('[D]', days);
  }

  refresh();
}
// Aviso común cuando cualquier script de la web cambia el carrito
if(!window.__fyoCartHook){
  window.__fyoCartHook = true;
  var isCart = function(u){ u = String(u || ''); return /\/cart\/(add|change|update|clear)/.test(u); };
  var notify = function(){ setTimeout(function(){ document.dispatchEvent(new CustomEvent('fyo:cart:changed')); }, 300); };
  if(window.fetch){ var of = window.fetch; window.fetch = function(input){ var url = typeof input === 'string' ? input : (input && input.url); var p = of.apply(this, arguments); if(isCart(url)) p.then(notify, function(){}); return p; }; }
  var oo = XMLHttpRequest.prototype.open; XMLHttpRequest.prototype.open = function(m, url){ if(isCart(url)) this.addEventListener('load', notify); return oo.apply(this, arguments); };
}
function initAll(){ document.querySelectorAll('.fyx').forEach(initFyx); }
if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', initAll); } else { initAll(); }
document.addEventListener('shopify:section:load', function(e){ initFyx(e.target.querySelector('.fyx')); });
})();